import { BaseModel } from 'ag-common-lib/lib/models/base.model';
import { ButtonAlignment, ButtonStylingMode, ButtonType, FormItemGroup, FormRow } from 'ag-common-lib/lib';
import { Headshot } from 'ag-common-lib/lib/models/utils/headshot.model';

export enum FormBuilderKeys {
  formName = 'formName',
  formID = 'formID',
  description = 'description',
  submitButtonText = 'submitButtonText',
  submitEndpoint = 'submitEndpoint',
  submitButtonStylingMode = 'submitButtonStylingMode',
  submitButtonType = 'submitButtonType',
  submitButtonAlignment = 'submitButtonAlignment',
  previewHeadshot = 'previewHeadshot',
  desktopFormHeight = 'desktopFormHeight',
  mobileFormHeight = 'mobileFormHeight',
  rows = 'rows',
  permissionConfigurationIds = 'permissionConfigurationIds',
}

export const FORM_BUILDER_LOOKUP = [{
  value: FormBuilderKeys.formName,
  description: 'Form Name'
}, {
  value: FormBuilderKeys.description,
  description: 'Description'
}];

export class FormBuilderData extends BaseModel {
  [FormBuilderKeys.formName]?: string = '';
  [FormBuilderKeys.formID]?: string = '';
  [FormBuilderKeys.description]?: string = '';
  [FormBuilderKeys.submitButtonText]?: string = 'SUBMIT';
  [FormBuilderKeys.submitEndpoint]?: string = '';
  [FormBuilderKeys.submitButtonStylingMode]?: ButtonStylingMode = ButtonStylingMode.contained;
  [FormBuilderKeys.submitButtonType]?: ButtonType = ButtonType.default;
  [FormBuilderKeys.submitButtonAlignment]?: ButtonAlignment = ButtonAlignment.right;
  [FormBuilderKeys.previewHeadshot]?: Headshot = null;
  [FormBuilderKeys.desktopFormHeight]?: number = null;
  [FormBuilderKeys.mobileFormHeight]?: number = null;
  [FormBuilderKeys.rows]?: FormRow[];
  [FormBuilderKeys.permissionConfigurationIds]?: string[];

  constructor() {
    super();

    const initialRow = Object.assign({}, new FormRow());

    initialRow.colCount = 1;

    this.rows = [initialRow];
  }
}

export type FormBuilderSubmitConfig = Pick<
  FormBuilderData,
  | FormBuilderKeys.submitButtonText
  | FormBuilderKeys.submitEndpoint
  | FormBuilderKeys.submitButtonStylingMode
  | FormBuilderKeys.submitButtonType
  | FormBuilderKeys.submitButtonAlignment
>;
